"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ThreeCircleFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ThreeCircleFilled = function ThreeCircleFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#F4F9E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.143 27.296c.072-1.992 1.008-3.072 2.664-3.072 1.44 0 2.4.888 2.4 2.256 0 .984-.504 1.752-1.368 2.04-.528.192-.864.24-2.112.24v1.944c.336-.048.576-.048.816-.048 2.064 0 3.192.936 3.192 2.64 0 1.728-1.127 2.832-2.88 2.832-1.968 0-2.976-1.104-3.048-3.336h-2.472v.336c0 3.072 2.184 5.136 5.448 5.136 3.264 0 5.544-2.064 5.544-5.04 0-1.872-1.055-3.24-2.831-3.696 1.343-.456 2.207-1.704 2.207-3.216 0-2.52-1.968-4.224-4.872-4.224-3.096 0-5.015 1.968-5.112 5.208h2.424z",
    fill: "#97BA1E"
  }));
};

exports.ThreeCircleFilled = ThreeCircleFilled;
var _default = ThreeCircleFilled;
exports.default = _default;